// 拍一拍文字数据库
export const categories = [
  { id: 'funny', name: '搞笑', icon: '😂', color: '#FF6B6B' },
  { id: 'warm', name: '暖心', icon: '💖', color: '#FF8E53' },
  { id: 'cute', name: '撒娇', icon: '🥺', color: '#FF9FF3' },
  { id: 'work', name: '职场', icon: '💼', color: '#54A0FF' },
  { id: 'festival', name: '节日', icon: '🎉', color: '#5F27CD' },
  { id: 'daily', name: '日常', icon: '☀️', color: '#00D2D3' },
  { id: 'love', name: '恋爱', icon: '💕', color: '#FF6B9D' },
  { id: 'friendship', name: '友情', icon: '👫', color: '#C44569' }
];

export const paiPaiTexts = {
  funny: [
    '拍了拍你，并说："今天也要做个可爱的沙雕哦"',
    '拍了拍你的脑袋，发现是空的',
    '拍了拍你，并偷偷放了个屁',
    '拍了拍你的钱包，发现比脸还干净',
    '拍了拍你，然后被你的美貌闪瞎了眼',
    '拍了拍你的肚子，听到了海的声音',
    '拍了拍你，并说："快醒醒，该搬砖了"',
    '拍了拍你的头，发现掉了一地的智商',
    '拍了拍你，然后转身就跑',
    '拍了拍你的脸，发现比城墙还厚'
  ],
  warm: [
    '拍了拍你，想给你一个大大的拥抱',
    '拍了拍你，愿你永远被温柔以待',
    '拍了拍你的肩膀，一切都会好起来的',
    '拍了拍你，你已经很棒了',
    '拍了拍你，愿你今天也充满阳光',
    '拍了拍你，记得要好好爱自己',
    '拍了拍你，世界因你而美好',
    '拍了拍你的手，陪你走过风风雨雨',
    '拍了拍你，你是最特别的存在',
    '拍了拍你，愿你被这个世界温柔以待'
  ],
  cute: [
    '拍了拍你，然后害羞地躲起来',
    '拍了拍你的手，想要牵手手',
    '拍了拍你，撒娇说："人家想你了嘛"',
    '拍了拍你的脸蛋，好想捏一捏',
    '拍了拍你，然后眨眨眼说："你最好了"',
    '拍了拍你，蹭蹭你的肩膀',
    '拍了拍你，嘟着嘴说："理理我嘛"',
    '拍了拍你的头，像摸小猫咪一样',
    '拍了拍你，然后钻进你怀里',
    '拍了拍你，软软糯糯地说："抱抱"'
  ],
  work: [
    '拍了拍你，提醒你今天的KPI',
    '拍了拍你的键盘，它也很累了',
    '拍了拍你，老板在看着你呢',
    '拍了拍你的电脑，它要罢工了',
    '拍了拍你，下班记得打卡哦',
    '拍了拍你的咖啡杯，续命神器',
    '拍了拍你，今天又是搬砖的一天',
    '拍了拍你的工位，这里是你的战场',
    '拍了拍你，加班费在向你招手',
    '拍了拍你的肩膀，打工人加油'
  ],
  festival: [
    '拍了拍你，祝你新年快乐！',
    '拍了拍你，圣诞快乐，圣诞老人来了',
    '拍了拍你，中秋节快乐，月饼分我一个',
    '拍了拍你，春节快乐，红包拿来',
    '拍了拍你，生日快乐，许个愿吧',
    '拍了拍你，情人节快乐，脱单了吗',
    '拍了拍你，万圣节快乐，不给糖就捣蛋',
    '拍了拍你，端午节快乐，粽子香不香',
    '拍了拍你，劳动节快乐，放假真香',
    '拍了拍你，国庆节快乐，祖国万岁'
  ],
  daily: [
    '拍了拍你，今天天气真不错',
    '拍了拍你，记得多喝热水',
    '拍了拍你，该吃饭了',
    '拍了拍你，早点睡觉哦',
    '拍了拍你，出门记得带伞',
    '拍了拍你，今天也要开心',
    '拍了拍你，别忘了锻炼身体',
    '拍了拍你，记得给家人打电话',
    '拍了拍你，今天又是美好的一天',
    '拍了拍你，要好好照顾自己'
  ],
  love: [
    '拍了拍你，想和你在一起',
    '拍了拍你的心，它在为我跳动吗',
    '拍了拍你，你就是我的全世界',
    '拍了拍你的手，想十指相扣',
    '拍了拍你，爱你三千遍',
    '拍了拍你的眼睛，里面有星星',
    '拍了拍你，想和你白头到老',
    '拍了拍你的嘴唇，想要亲一口',
    '拍了拍你，你是我的小甜心',
    '拍了拍你，愿意和我共度余生吗'
  ],
  friendship: [
    '拍了拍你，好兄弟一辈子',
    '拍了拍你的肩膀，有我在呢',
    '拍了拍你，咱们是最好的朋友',
    '拍了拍你，一起去浪吧',
    '拍了拍你，友谊万岁',
    '拍了拍你的背，我永远支持你',
    '拍了拍你，有福同享有难同当',
    '拍了拍你的头，我的好朋友',
    '拍了拍你，咱们的友谊比海深',
    '拍了拍你，谢谢你一直陪伴我'
  ]
};
